import React, { Component } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import globals from '../globals';

class OutageGuarantee extends Component {

    componentDidMount() {
        this.controller = globals.genericAnimation(this.content);
    }

    componentWillUnmount() {
        globals.destroy(this.controller);
    }

    render() {
        return (
            <div className="outage-guarantee">
                <div className="inner">
                    <div className="row" ref={el => this.content = el}>
                        <div className="col-md-3 col-md-offset-2 col-xs-12">
                            <h1>Credit for outage.<br/>Your guarantee.</h1>
                            <p>Exetel will provide you with a designated service up time per calendar month basis. In the event that we do not deliver the service covered under the SLA at the level(s) guaranteed then a schedule of rebates of the monthly access fee will apply.</p>
                        </div>
                        <div className="col-md-4 col-md-offset-1 col-xs-12">
                            <BrowserView>
                                <img src="/images/outage-guarantee.svg" alt="Outage Guarantee" />
                            </BrowserView>
                            <MobileView>
                                <img src="/images/outage-guarantee-mobile.svg" alt="Outage Guarantee" className="mobile" />
                            </MobileView>
                        </div>
                    </div>
                </div>
                <div className="bottom-wave-darkgreen" />
            </div>
        );
    }

}

export default OutageGuarantee;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/OutageGuarantee.js